import {findAll, find, onReady, hasClass, addClass} from "../../../../modules/vegas/js/util";

function initCone() {
	[...findAll('.vg-clone-element')].forEach((el) => {
		let width = 1199;

		if (window.innerWidth <= width) {
			if (!hasClass(el, 'vg-element-cloned')) {
				let clone = el.cloneNode(true),
					target = el.dataset.target || 'vg-clone-area',
					targetCloneElement = find('.' + target);

				if (targetCloneElement) {
					targetCloneElement.append(clone);
					addClass(el, 'vg-cloned-element');

					el.remove();
				}
			}
		}
	});
}

onReady(initCone);
typeof onTurboRender !== 'undefined' && onTurboRender(initCone);
